import { __awaiter } from "tslib";
import { isVuid, makeVuid } from './vuid';
export class VuidCacheManager {
    constructor(cache, logger) {
        this.vuidCacheKey = 'optimizely-vuid';
        this.waitPromise = Promise.resolve();
        this.cache = cache;
        this.logger = logger;
    }
    setCache(cache) {
        this.cache = cache;
        this.vuid = undefined;
    }
    setLogger(logger) {
        this.logger = logger;
    }
    serialize(fn) {
        return __awaiter(this, void 0, void 0, function* () {
            const resultPromise = this.waitPromise.then(fn, fn);
            this.waitPromise = resultPromise.catch(() => { });
            return resultPromise;
        });
    }
    remove() {
        return __awaiter(this, void 0, void 0, function* () {
            const removeFn = () => __awaiter(this, void 0, void 0, function* () {
                if (!this.cache) {
                    return;
                }
                this.vuid = undefined;
                yield this.cache.remove(this.vuidCacheKey);
            });
            return this.serialize(removeFn);
        });
    }
    load() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.vuid) {
                return this.vuid;
            }
            const loadFn = () => __awaiter(this, void 0, void 0, function* () {
                if (!this.cache) {
                    return;
                }
                const cachedValue = yield this.cache.get(this.vuidCacheKey);
                if (cachedValue && isVuid(cachedValue)) {
                    this.vuid = cachedValue;
                    return this.vuid;
                }
                const newVuid = makeVuid();
                yield this.cache.set(this.vuidCacheKey, newVuid);
                this.vuid = newVuid;
                return newVuid;
            });
            return this.serialize(loadFn);
        });
    }
}
export class DefaultVuidManager {
    constructor(config) {
        this.vuidEnabled = false;
        this.vuidCacheManager = config.vuidCacheManager;
        this.vuidEnabled = config.enableVuid || false;
        this.vuidCache = config.vuidCache;
    }
    getVuid() {
        return this.vuid;
    }
    isVuidEnabled() {
        return this.vuidEnabled;
    }
    /**
     * initializes the VuidManager
     * @returns Promise that resolves when the VuidManager is initialized
     */
    initialize() {
        return __awaiter(this, void 0, void 0, function* () {
            this.vuidCacheManager.setCache(this.vuidCache);
            if (!this.vuidEnabled) {
                yield this.vuidCacheManager.remove();
                return;
            }
            this.vuid = yield this.vuidCacheManager.load();
        });
    }
}
export const __platforms = ['__universal__'];
//# sourceMappingURL=vuid_manager.js.map